import store from '@/store'
import { MessageBox } from 'element-ui'
export function checkLogin() {
  if (!store.getters.isLogin) {
    MessageBox.confirm('当前账号未登录，是否去登录？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        window.open('https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330201271550202305000005_1&sp=', '_self')
      })
      .catch(() => {})
      .finally(() => {})
    return false
  }
  return true
}
